import {
  combineReducers
} from 'redux'
import {
  NEWS,
  POPULAR_NEWS,
  NEWS_DETAILS
} from '../../actions/actionTypes'
import {
  fetchingData,
  initStateLang
} from '../../utils'

const initailState = {
  loading: false,
  error: '',
  data: [],
  lastUpdate: ''
}

const list = (state = initStateLang(initailState, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case NEWS.REQUEST:
    return {
      ...state,
      loading: true,
      error: '',
    }
  case NEWS.SUCCESS:
    return {
      ...state,
      loading: false,
      error: '',
      [action.lang]: { data: action.data, lastUpdate: action.lasted }
    }
  case NEWS.FAILURE:
    return {
      ...state,
      loading: false,
      error: action.error,
    }
  default:
    return state
  }
}
const popular = (state = initStateLang(initailState, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case POPULAR_NEWS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      }
    case POPULAR_NEWS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        [action.lang]: { data: action.data, lastUpdate: action.lasted }
      }
    case POPULAR_NEWS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}
const initailStateDetail = {
  loading: false,
  error: '',
  data: {},
  lastUpdate: ''
}
const details = (state = initStateLang(initailStateDetail, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case NEWS_DETAILS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        [action.lang]: { data: {} }
      }
    case NEWS_DETAILS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        [action.lang]: { data: action.data, lastUpdate: action.lasted }
      }
    case NEWS_DETAILS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}
export default combineReducers({
  list,
  popular,
  details
})


// WEBPACK FOOTER //
// ./src/containers/News/reducer.js